// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__203HQ","newExpiryDate":"styles_newExpiryDate__3zyMn","footer":"styles_footer__3A1p2"};